import React from "react";
import "./oauth-loading-message.scss";
import Loader from "app/pages/.shared/Loader";
import { FormattedMessage } from "react-intl";

class OAuthLoadingMessage extends React.PureComponent {
	render() {
		return (
			<div className="oauth-loading-message">
				<Loader />
				<FormattedMessage id="oauth.loading.message" />
			</div>
		);
	}
}

OAuthLoadingMessage.propTypes = {};

export default OAuthLoadingMessage;
